import * as React from "react";
import SEO from "../components/seo";
import Layout from "../components/layout";
import SimpleHero from "../components/v2/simple-hero";
import FiftyFiftyHorizontal from "../components/v2/fifty-fifty-horizontal";
import ImageGridBanner from "../components/v2/image-grid-banner";
import MediaSlider from "../components/v2/media-slider";
import GetUpdates from "../components/v2/get-updates";
import DetailsFooter from "../components/v2/details-footer";

// Hooks
import useLevel9SportsPageImages from "../hooks/useLevel9SportsPageImages";
import Quote from "../components/v2/quote";
import HeadlineBanner from "../components/v2/headline-banner";
import ArrowLink from "../components/global/arrow-link";

const LevelNineSports = () => {
  return (
    <Layout
      className="template-details"
      bodyTheme="light"
      isFooter={false}
      headerLayout="mobile"
    >
      <SEO title="Level Nine Sports" />
      <SimpleHero
        contentData={
          {
            pre_title: "Level Nine",
            title: "Sports",
          }
        }
        imageData={useLevel9SportsPageImages({name: "level-9-sports-1"})}
      />
      <section className="spacing spacing--general">
        <HeadlineBanner
          pre_title="Born in the"
          title="Wasatch"
        />
        <section className="spacing spacing--spacing-top-1">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-8">
                <Quote
                  quote="The collaboration with evo is a huge positive for Level Nine Sports. I liken it to the famous idiom, 'A rising tide lifts all boats.' Both Bryce and I feel like we can add a ton of value to the customer – in the same way we’ve been doing it for years. And I think it will only be a net positive with us coming together and participating in this project.”"
                  author="Mitch Lamb,"
                  position="CEO Level Nine Sports"
                />
              </div>
            </div>
          </div>
        </section>
      </section>
      <FiftyFiftyHorizontal
        mediaPosition="left"
        contentColumns={5}
        contentOffset={1}
        mediaColumns={6}
        mediaOffset={0}
        imageData={useLevel9SportsPageImages({name: "level-9-sports-2"})}
      >
        <p>Level Nine Sports was born in the Wasatch in 2005 and has specialized in outfitting mountain sports enthusiasts with the best gear ever since. With a focus on value and quality, L9’s mission is to bring skiing, snowboarding and mountain biking to the masses with exceptional prices and expertise.</p>
        <p className="flex-copy">
          <span>Open daily, 10AM-6PM</span>
          <span><a className="dark" href="tel: +1 (801) 973-7350">(801) 973-7350</a></span>
          <span>
            <ArrowLink
              isExternalLink={true}
              to="https://www.levelninesports.com/retail/salt-lake-city-utah-ski-shop"
              text="Learn More"
              theme="dark-body"
            />
          </span>
        </p>
      </FiftyFiftyHorizontal>
      <ImageGridBanner
        className="spacing spacing--spacing-3"
        imageData={useLevel9SportsPageImages({name: "level-9-sports-3"})}
      />
      <FiftyFiftyHorizontal
        contentColumns={5}
        contentOffset={1}
        mediaColumns={5}
        mediaOffset={1}
        imageData={useLevel9SportsPageImages({name: "level-9-sports-4"})}
      >
        <p>L9 started as an online retailer but has since opened four stores in Utah in order to serve their local clientele.</p>
        <p>With the opening of their new campus location, L9 is excited to expand their reach and be part of an outdoor hub that’s focused on helping people explore the Salt Lake area.</p>
      </FiftyFiftyHorizontal>
      <MediaSlider
        className="spacing spacing--general"
        slides={[
          {
            imageData: useLevel9SportsPageImages({name: "level-9-sports-slider-1"}),
            description: "",
          },
          {
            imageData: useLevel9SportsPageImages({name: "level-9-sports-slider-2"}),
            description: "",
          },
          {
            imageData: useLevel9SportsPageImages({name: "level-9-sports-slider-3"}),
            description: "",
          },
        ]}
      />
      <GetUpdates
        className="spacing spacing--general"
      />
      <DetailsFooter
        imageData={useLevel9SportsPageImages({name: "level-9-sports-5"})}
        imageDataHover={useLevel9SportsPageImages({name: "level-9-sports-6"})}
        linkData={{
          title: "Read Story",
          project_url: "/market-hall/",
        }}
        pre_title="Up Next"
        title="The Market Hall"
      />
    </Layout>
  )
}

export default LevelNineSports
